import styled from 'styled-components';
import { Text } from '../text/index.js';
export const LabelElement = styled((Text)) ``;
//# sourceMappingURL=label.styles.js.map